import { AccountSelector } from '@/design-system/components/accountSelector/AccountSelector';
import { AlertType, UniAlert } from '@/design-system/components/alerts';
import { UniButton } from '@/design-system/components/buttons';
import { Divider } from '@/design-system/components/Divider';
import { BottomSheetHeader } from '@/design-system/components/headers';
import { H6, TextBody, TextCaption } from '@/design-system/components/typography';
import { formatAmountByDecimals } from '@/utils/numberFormatting';
import { ScrollView, SxProp, View } from 'dripsy';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RootStackRoutes } from 'types';
import { GetBrokersResponseItem } from '@utx/utx-client';
import ExchangeBanner from '../../../../assets/svg/ExchangeBanner.svg';
export interface ViewAllCardProps {
  onClose: () => void;
}

export const ViewAllCardWebScreen: React.FC<ViewAllCardProps> = (props) => {
  const { onClose } = props;
  const { t } = useTranslation('account-management');
  const {
    topHeader,
    body,
    viewBinance,
    viewBinanceBackground,
    viewDropdownAbsolute,
    horizontalWrapper,
    textLabel,
    textDebitAmount,
    textValueDebitAmount,
    viewBinanceWrapper,
    textBinance,
    textMonthlyFeeNote,
    button,
    iconWrapper,
    textInsufficient
  } = sxStyles;

  const displayAmountWithCurrency = (amountString: string, currency: string) => {
    const amount = parseFloat(amountString);
    return `${amount < 0 ? '-' : ''}${formatAmountByDecimals({ value: Math.abs(amount), decimals: 2 })} ${currency ?? 'HKD'}`;
  };

  return (
    <ScrollView>
      <View>
        <View sx={topHeader}>
          <BottomSheetHeader
            title={t('exchange-account::select-exchange-account.title--application-instruction-confirmation')}
            onPress={onClose}
            sx={{ paddingX: 28, pb: 0 }}
          />
        </View>
        <Divider />
        <View sx={body}>
          <TextBody semiBold>{t('exchange-account::confirmation.text--you-have-selected-account')}</TextBody>
          <View sx={viewBinance}>
            <View sx={viewBinanceBackground}>
              <ExchangeBanner width={'100%'} height={'100%'} />
            </View>
            <View sx={viewBinanceWrapper}>
              <H6 bold sx={textBinance}>
                view all card
              </H6>
            </View>
          </View>

          <View
            sx={{
              ...horizontalWrapper,
              ...{ mb: '$5' }
            }}>
            <TextCaption sx={textLabel}>{t('exchange-account::glossary.balance')}</TextCaption>
          </View>
          <View
            sx={{
              ...horizontalWrapper,
              ...{ mb: '$3' }
            }}>
            <TextBody sx={textLabel}>{t('exchange-account::glossary.account-application-fee')}</TextBody>
          </View>
          <View
            sx={{
              ...horizontalWrapper,
              ...{ mb: '$3' }
            }}>
            <TextBody sx={textLabel}>{t('exchange-account::glossary.est-account-opening-time')}</TextBody>
          </View>
          <View sx={{ mb: '$5' }}>
            <View
              sx={{
                ...horizontalWrapper,
                ...{ mb: '$1' }
              }}>
              <TextBody sx={textLabel}>{t('exchange-account::glossary.monthly-fee')}</TextBody>
            </View>
            <TextBody sx={textMonthlyFeeNote}>{t('general::deducted-end-of-each-month')}</TextBody>
          </View>
          <Divider />
          <TextCaption semiBold sx={textDebitAmount}>
            {t('exchange-account::glossary.debit-amount')}
          </TextCaption>
        </View>
      </View>
    </ScrollView>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    flex: 1,
    paddingX: '$4',
    backgroundColor: '$backgroundPrimary'
  },
  topHeader: {
    height: 76,
    justifyContent: 'center'
  },
  body: {
    minHeight: 200,
    px: 28,
    py: 28
  },
  viewBinance: {
    height: 70,
    gap: 20,
    borderRadius: '$radius2',
    my: '$5',
    overflow: 'hidden'
  },
  viewFilterDropdown: {
    width: '100%',
    borderRadius: '$radius1',
    borderColor: '#CCCCCC',
    borderWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '$4',
    my: '$1',
    height: 48,
    zIndex: 1000
  },
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mt: '$5',
    mb: '$1',
    color: '$textPrimary'
  },
  textValueDebitAmount: {
    mb: '$1',
    color: '$danger'
  },
  button: {
    height: 44,
    mt: '$10'
  },
  viewBinanceBackground: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  },
  viewBinanceWrapper: {
    flexDirection: 'row',
    width: '100%',
    height: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    px: '$5'
  },
  textBinance: {
    color: '$textDarkBackground'
  },
  viewDropdownAbsolute: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '$4',
    height: '$11'
  },
  textMonthlyFeeNote: {
    color: '$textSecondary'
  },
  iconWrapper: {
    height: '100%',
    alignItems: 'flex-end',
    justifyContent: 'center'
  },
  textInsufficient: {
    color: '$danger',
    mt: '$3'
  }
};
